import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/styles';
import CustomLayout from 'component/layout/custom_layout';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import config from 'config';
import { useStyles } from 'containers/stylist_profile/style';
import { SEARCH_STYLE, SEARCH_STYLE_TYPE } from 'graph_ql/search/search_style';
import { useCallback, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { Waypoint } from 'react-waypoint';
import themes from 'styles/themes';
import { checkIsPersonalizedStyle, getProductTrackingData } from 'utils/trackUtils';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { TRACK_EVENT, trackEvent } from 'utils/analytics';

const allRelatedStyles = makeStyles({
    main: {
        padding: '24px',
        backgroundColor: themes.palette.primary.light,
        marginTop: '36px',
        borderRadius: '16px',
        height: 'calc(100% - 86px)',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        '&Empty': {
            backgroundColor: 'transparent',
        },
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    styleBox: {
        overflowY: 'scroll',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: '-8px',
        marginRight: '-8px',
        height: '100%',
    },
    styleItem: {
        width: '50%',
        padding: '0 8px 20px',
    },
    styleCard: {
        width: '100%',
        height: 'auto',
        margin: '15px 10px',
    },
    styleCardImg: {
        width: '100%',
        height: 200,
        aspectRatio: '1',
        borderRadius: 8,
        objectFit: 'cover',
        objectPosition: 'center',
    },
    styleCardText: {
        color: themes.palette.primary.main,
        fontSize: 12,
        fontWeight: 400,
        marginTop: 10,
        marginBottom: 0,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        marginTop: -10,
    },
});

function ViewRelatedStyles() {
    const [listStyle, setListStyle] = useState<any[]>([]);
    const { itemTaffiId } = useParams<{ itemTaffiId: string }>();
    const history = useHistory();
    const pageStyles = allRelatedStyles();
    const classes = useStyles();
    const userDetail = useSelector((state: RootState) => state.userDetail.me);

    const searchVariables = useMemo(() => {
        let index = 'styles';

        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles,
            index: config.algolia.algolia_prefix + index,
            query: itemTaffiId,
            filters: `status:published`,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [],
        };
    }, [itemTaffiId]);

    const { loading: stylesLoading } = useQuery(SEARCH_STYLE, {
        variables: searchVariables,
        onCompleted(response) {
            setListStyle(response?.locationsInRadius?.hits);
        },
    });

    const handleStyleItemClick = (style) => {
        history.push(`${PATH.STYLE_DETAIL}/${style.taffiId}`);
    };

    const trackProductView = useCallback(
        (styleData) => {
            const productViewTrackingData = {
                ...getProductTrackingData(userDetail, styleData, styleData),
                personalized: checkIsPersonalizedStyle(styleData, userDetail),
            };
            trackEvent(TRACK_EVENT.PRODUCT_VIEW, productViewTrackingData);
        },
        [userDetail],
    );

    const _handleWaypointEnter = (item) => {
        trackProductView(item);
    };

    return (
        <>
            <CustomLayout title="All styles" showBackBtn={false} backTo="/home" showHeader={true}>
                <div id="main" className={classes.main} style={{ height: '100%' }}>
                    {!stylesLoading && (
                        <>
                            {listStyle.length > 0 ? (
                                <div className={pageStyles.styleBox}>
                                    {listStyle.map((style) => (
                                        <Waypoint onEnter={() => _handleWaypointEnter(style)}>
                                            <div
                                                className={pageStyles.styleItem}
                                                onClick={() => handleStyleItemClick(style)}
                                                key={style.id}
                                            >
                                                <img src={style.images[0]} alt="" className={pageStyles.styleCardImg} />
                                                <p className={pageStyles.styleCardText}>{style.title}</p>
                                            </div>
                                        </Waypoint>
                                    ))}
                                </div>
                            ) : null}
                        </>
                    )}
                </div>
            </CustomLayout>
            {stylesLoading && <LoadingDataSpinner isBackground={true} />}
        </>
    );
}

export default ViewRelatedStyles;
